import { render } from "./Applies.vue?vue&type=template&id=6743970a&scoped=true"
import script from "./Applies.vue?vue&type=script&lang=js"
export * from "./Applies.vue?vue&type=script&lang=js"

import "./Applies.vue?vue&type=style&index=0&id=6743970a&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6743970a"]])

export default __exports__